import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptDecrypt {
  private cost: number = 3;
  private key = this.decode(window.localStorage.getItem('_temp')!);
  constructor() {}
  setKey(key: string) {
    this.key = this.encodeUsingBase64(key);
    return this.key;
  }
  encrypt(text: any) {
    if (!text) return;
    let encryptedText = text;
    for (let i = 0; i < this.cost; i++) {
      encryptedText = this.encryptUsingAES256(encryptedText);
    }
    return encryptedText;
  }
  decrypt(text: any) {
    if (!text) return null;
    let decryptedText = text;
    for (let i = 0; i < this.cost; i++) {
      decryptedText = this.decryptUsingAES256(decryptedText);
    }
    return JSON.parse(decryptedText);
  }
  encryptUsingAES256(text: string) {
    let _key = CryptoJS.enc.Utf8.parse(this.encode(this.key));
    let _iv = CryptoJS.enc.Utf8.parse(this.encode(this.key));
    let encrypted = CryptoJS.AES.encrypt(text, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }
  decryptUsingAES256(encryptedText: string) {
    let _key = CryptoJS.enc.Utf8.parse(this.encode(this.key));
    let _iv = CryptoJS.enc.Utf8.parse(this.encode(this.key));

    let decrypted = CryptoJS.AES.decrypt(encryptedText, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }
  encode(text: any) {
    if (!text) return;
    let encodedText = text;

    for (let i = 0; i < this.cost; i++) {
      encodedText = this.encodeUsingBase64(encodedText);
    }

    return encodedText;
  }
  decode(text: any) {
    if (!text) return;
    let decodedText = text;
    for (let i = 0; i < this.cost; i++) {
      decodedText = this.decodeUsingBase64(decodedText);
    }
    return decodedText;
  }
  encodeUsingBase64(text: string) {
    return btoa(text).toString();
  }
  decodeUsingBase64(text: string) {
    return atob(text).toString();
  }
}
